import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUserData } from '@/lib/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export default function ProtectedRoute({ children, requireAdmin }: ProtectedRouteProps) {
  const authenticated = isAuthenticated();
  const userData = getUserData();

  // If not authenticated, redirect to login page
  if (!authenticated) {
    return <Navigate to="/area-cliente" replace />;
  }

  // If admin access is required, check if user has admin role
  if (requireAdmin) {
    // Check if user is internal (admin or support) - role_id 1, 2, or 4 can access admin features
    const hasAdminAccess = userData?.user_type === 'internal' && (userData?.role_id === 1 || userData?.role_id === 2 || userData?.role_id === 4);
    
    if (!hasAdminAccess) {
      // Not an admin/support, redirect to client dashboard
      return <Navigate to="/cliente/dashboard" replace />;
    }
  }

  return <>{children}</>;
}
